import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { RoleSectionPermissionsComponent }
	from '@app/modules/system-settings/user-management/roles/role-detail/role-section-permissions/role-section-permissions.component';

/**
 * Formly field type that hosts a {@link RoleSectionPermissionsComponent}.
 *
 * @remarks
 * The field's model value is the `RolePermissionsModel`. The hosted component edits claim values in place, so when it
 * emits `changed` the control is re-set with the same reference to mark it dirty and notify `valueChanges` subscribers.
 * Set `props.readOnly` (or `props.disabled`) to display the values without allowing changes.
 */
@Component({
	selector: 'formly-role-section-permissions',
	standalone: true,
	imports: [RoleSectionPermissionsComponent],
	template: `
		<sb-role-section-permissions
			[permissions]="formControl.value"
			[readOnly]="!!(props.readOnly || props.disabled)"
			(changed)="onChanged()"
		></sb-role-section-permissions>
	`,
})
export class FormlyRoleSectionPermissionsComponent extends FieldType<FieldTypeConfig> {
	/** Flags the control as changed after the hosted component mutates the permissions in place. */
	onChanged(): void {
		this.formControl.setValue(this.formControl.value);
		this.formControl.markAsDirty();
		this.props.change?.(this.field, this.formControl.value);
	}
}
